import React, { useEffect, useState } from 'react'
import { Platform, View, type ViewStyle } from 'react-native'
import { useReducedMotion } from 'react-native-reanimated'
import { initialRevealOptions } from '../../lib/initialReveal'

type RevealStyle = ViewStyle & { transitionProperty: string; transitionDuration: string; transitionTimingFunction: string }

/** Let the first measured game layout settle, then reveal without translating it. */
export function InitialGameReveal({ children }: { children: React.ReactNode }) {
  const reducedMotion = useReducedMotion()
  const options = initialRevealOptions(Platform.OS === 'web', reducedMotion)
  const [visible, setVisible] = useState(options.opacity === 1)
  useEffect(() => {
    if (!options.duration) { setVisible(true); return }
    let frame: number
    let remaining = options.settleFrames
    function settle() {
      if (--remaining > 0) { frame = requestAnimationFrame(settle); return }
      setVisible(true)
    }
    frame = requestAnimationFrame(settle)
    return () => cancelAnimationFrame(frame)
  }, [options.duration, options.settleFrames])
  if (Platform.OS !== 'web') return <View style={{ flex: 1 }}>{children}</View>
  // CSS uses the browser's compositor clock, independent of the fixture clock.
  // Keeping these properties on the web branch also avoids native DOM styles.
  const style: RevealStyle = { flex: 1, opacity: visible ? 1 : 0,
    transitionProperty: 'opacity', transitionDuration: `${options.duration}ms`, transitionTimingFunction: 'ease-out' }
  return <View style={style}>{children}</View>
}
